import type { ActorKind } from '@garage/shared';

/**
 * Classes des écrans de la vague 4 (lot L5), construites uniquement sur les jetons du design
 * (`shared/styles.css`, `docs/DESIGN.md`) : aucune couleur en dur. Chaînes complètes (pas de
 * concaténation) pour que Tailwind les détecte.
 */
export const tone = {
  surface: 'bg-surface',
  surfaceMuted: 'bg-sunken',
  border: 'border-line',
  borderStrong: 'border-line-strong',
  text: 'text-ink',
  textSoft: 'text-ink-2',
  textMuted: 'text-ink-3',
  danger: 'text-danger-fg',
  dangerBox: 'border-danger-line bg-danger-bg text-danger-fg',
  successBox: 'border-success-line bg-success-bg text-success-fg',
  overlay: 'bg-ink/75 text-surface',
  dropActive: 'border-brand-strong bg-brand-soft',
} as const;

/**
 * Bulles de messages : couleurs d'auteur indépendantes de la marque (décision du porteur), les
 * mêmes côté garage et côté client. Client : jetons `author-customer` ; garage : surface bordée.
 */
export const bubble = {
  garage: 'border border-line bg-surface text-ink',
  customer: 'border border-author-customer/25 bg-author-customer-bg text-author-customer-fg',
} as const;

export type AuthorTone = 'author-garage' | 'author-customer' | 'author-system' | 'author-support';

/** Auteur du journal → ton de pastille et libellé (jamais la couleur seule). */
export const ACTOR_TONE: Record<ActorKind, AuthorTone> = {
  garage: 'author-garage',
  customer: 'author-customer',
  automatic: 'author-system',
  platform: 'author-support',
};

/** Pastille pleine de la couleur d'auteur (légende des filtres). */
export const ACTOR_DOT: Record<ActorKind, string> = {
  garage: 'bg-author-garage',
  customer: 'bg-author-customer',
  automatic: 'bg-author-system',
  platform: 'bg-author-support',
};

export const ACTOR_LABELS: Record<ActorKind, string> = {
  garage: 'Garage',
  customer: 'Client',
  automatic: 'Automatique',
  platform: 'Support',
};
